module.exports = __webpack_public_path__ + "img/logo.333f2d13.png";